module.exports = __webpack_public_path__ + "static/img/06022D_X_04_20170725_LC.4f87a74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06022D_X_04_20170725_LC.png
// module id = hmw+
// module chunks = 0